import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-not-authroized',
    templateUrl: './page-not-authroized.component.html',
    styleUrls: ['./page-not-authroized.component.scss'],
})
export class PageNotAuthroizedComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
